import React from "react";
import DecisionUploadButton from "../../previewDocuments/DecisionAcceptance/DecisionUploadButton";

function DecisionUpload({
  dispatchUpdateAction,
  documents,
  requests,
  className = "",
  uploadUrl = `${process.env.REACT_APP_GATEWAY_URL}/upload`,
  formDataAsJson,
  acceptDocumentTypes = "",
}) {
  return (
    <div className={`${className}`}>
      <DecisionUploadButton
        uploadUrl={uploadUrl}
        requests={requests}
        formDataAsJson={formDataAsJson}
        acceptDocumentTypes={acceptDocumentTypes}
      />
    </div>
  );
}

export default DecisionUpload;
